import React from 'react'

import type {
  EmptyStateProps,
  EmptyStateWithIconProps,
  EmptyStateWithIllustrationProps,
} from './EmptyState.types'

import EmptyStateWithIcon from './EmptyStateWithIcon'
import EmptyStateWithIllustration from './EmptyStateWithIllustration'
import Illustration from './Illustration'

const EmptyState = (props: EmptyStateProps): JSX.Element => {
  if (['card', 'horizontal-card'].includes(props.variant)) {
    return <EmptyStateWithIcon {...(props as EmptyStateWithIconProps)} />
  }
  return <EmptyStateWithIllustration {...(props as EmptyStateWithIllustrationProps)} />
}

EmptyState.Illustration = Illustration

export default EmptyState
